import { listComponentCss } from "survey-creator-core";

export var presetsCss = {
  root: "sps-root-modern",
  container: "sps-container-modern",
  header: "sps-title sps-container-modern__title",
  body: "sps-body",
  bodyEmpty: "sps-body sps-body--empty",
  footer: "sps-footer sps-body__footer sps-clearfix",
  title: "",
  description: "",
  logo: "sps-logo",
  logoImage: "sps-logo__image",
  headerText: "sps-header__text",
  navigationButton: "",
  bodyNavigationButton: "",
  completedPage: "sps-completedpage",
  navigation: {
    complete: "sps-btn sps-btn--primary-brand sps-footer__complete-btn",
    prev: "sps-btn sps-btn--secondary-brand sps-footer__prev-btn",
    next: "sps-btn sps-btn--primary-brand sps-footer__next-btn",
    start: "sps-btn sps-footer__start-btn",
    preview: "sps-btn sps-footer__preview-btn",
    edit: "sps-btn sps-footer__edit-btn"
  },
  list: JSON.parse(JSON.stringify(listComponentCss)),
  panel: {
    withFrame: "sps-panel--with-frame",
    nested: "sps-panel--nested",
    expandableAnimating: "",
    header: "sps-panel__header",
    title: "sps-title sps-panel__title",
    titleBar: "sd-action-title-bar sps-action-title-bar",
    contentEnter: "sps-panel__content--enter",
    contentLeave: "sps-panel__content--leave",
    titleExpandable: "sps-panel__title--expandable",
    titleExpanded: "sps-panel__title--expanded",
    titleCollapsed: "sps-panel__title--collapsed",
    titleOnError: "sps-panel__title--error",
    description: "sps-description sps-panel__description",
    container: "sps-panel sps-row__panel",
    content: "sps-panel__content",
    icon: "sps-panel__icon",
    iconExpanded: "sps-panel__icon--expanded",
    footer: "sps-panel__footer",
    requiredMark: "sps-panel__required-text",
    collapsed: "sps-panel--collapsed",
    expanded: "sps-panel--expanded",
  },
  paneldynamic: {
    nested: "",
    mainRoot: "sps-question sps-row__question",
    root: "sps-paneldynamic",
    navigation: "sps-paneldynamic__navigation",
    title: "sps-title sps-question__title",
    button: "sps-action-button sps-action-button--text",
    buttonRemove: "sps-action-button--danger",
    buttonAdd: "sps-paneldynamic__add-btn",
    panelsContainer: "",
    panelWrapper: "sps-paneldynamic__panel-wrapper",
    panelWrapperList: "",
    progressTop: "sps-paneldynamic__progress sps-paneldynamic__progress--top",
    progressBottom:
      "sps-paneldynamic__progress sps-paneldynamic__progress--bottom",
    buttonPrev: "sps-paneldynamic__prev-btn",
    buttonNext: "sps-paneldynamic__next-btn",
    progressContainer: "sps-paneldynamic__progress-container",
    progress: "sps-progress",
    progressBar: "sps-progress__bar",
    progressText: "sps-paneldynamic__progress-text",
    panelFooter: "sps-panel__footer",
    separator: "sps-paneldynamic__separator",
    footer: "sps-paneldynamic__footer",
    footerButtonsContainer: "sps-paneldynamic__buttons-container",
  },
  progress: "sps-progress sps-body__progress",
  progressBar: "sps-progress__bar",
  progressText: "sps-progress__text",
  progressTextInBar: "sps-hidden",
  page: {
    root: "sps-page sps-body__page",
    title: "sps-title sps-page__title",
    description: "sps-description sps-page__description"
  },
  pageTitle: "sps-title sps-page__title",
  pageDescription: "sps-description sps-page__description",
  row: "sps-row sps-clearfix",
  rowEnter: "sps-row--enter",
  rowLeave: "sps-row--leave",
  rowDelayedEnter: "sps-row--delayed-fade-in",
  rowMultiple: "sps-row--multiple",
  question: {
    withFrame: "sps-question--with-frame",
    nested: "sps-question--nested",
    mainRoot: "sps-question sps-row__question",
    flowRoot: "sps-question sps-row__question sps-row__question--flow",
    asCell: "sps-table__cell",
    header: "sps-question__header",
    headerLeft: "sps-question__header--location--left",
    headerTop: "sps-question__header--location--top",
    headerBottom: "sps-question__header--location--bottom",
    content: "sps-question__content",
    contentLeft: "sps-question__content--left",
    titleLeftRoot: "sps-question--location--left",
    titleOnAnswer: "sps-question__title--answer",
    titleOnError: "sps-question__title--error",
    title: "sps-title sps-question__title",
    titleBar: "sd-action-title-bar sps-action-title-bar",
    requiredMark: "sps-question__required-text",
    number: "sps-question__num",
    description: "sps-description sps-question__description",
    descriptionUnderInput: "sps-question__description--under",
    comment: "sps-comment",
    required: "sps-question--required",
    titleRequired: "sps-question__title--required",
    indent: 0,
    footer: "sps-question__footer",
    formGroup: "sps-question__form-group",
    hasError: "",
    readOnly: "sd-question--readonly sps-question--disabled",
    confirmDialog: "sps-popup--confirm sv-popup--confirm svc-creator-popup",
    errorsContainerBottom: "sps-question__erbox--below-question",
  },
  checkbox: {
    root: "sps-selectbase",
    item: "sps-item sps-checkbox sps-selectbase__item",
    itemSelectAll: "sps-checkbox--selectall",
    itemNone: "sps-checkbox--none",
    itemReadOnly: "sps-item--disabled sps-checkbox--disabled",
    itemChecked: "sps-checkbox--checked",
    itemHover: "sps-checkbox--allowhover",
    itemInline: "sps-selectbase__item--inline",
    label: "sps-selectbase__label",
    // label: "sps-checkbox",
    itemSvgIconId: "#icon-check-16x16",
    labelChecked: "",
    //itemControl: "sps-visuallyhidden sps-item__control",
    itemControl: "sps-checkbox__control",
    itemDecorator: "sps-checkbox__svg",
    //itemDecorator: "sps-checkbox__hidden",
    //controlLabel: "sps-item__control-label",
    controlLabel: "sps-checkbox__caption",
    materialDecorator: "sps-checkbox__rectangle",
    //materialDecorator: "sps-item__decorator sps-checkbox__decorator",
    other: "sps-comment sps-question__other",
    column: "sps-selectbase__column"
  },
  radiogroup: {
    root: "sps-selectbase",
    item: "sps-item sps-radio sps-selectbase__item",
    itemInline: "sps-selectbase__item--inline",
    label: "sps-selectbase__label",
    labelChecked: "",
    itemReadOnly: "sps-item--disabled sps-radio--disabled",
    itemChecked: "sps-radio--checked",
    itemHover: "sps-radio--allowhover",
    itemControl: "sps-visuallyhidden sps-item__control",
    itemDecorator: "sps-item__svg sps-radio__svg",
    controlLabel: "sps-item__control-label",
    materialDecorator: "sps-item__decorator sps-radio__decorator",
    other: "sps-comment sps-question__other",
    clearButton: "sps-btn sps-selectbase__clear-btn",
    column: "sps-selectbase__column"
  },
  boolean: {
    mainRoot: "sps-question sps-row__question sps-question--boolean",
    rootCheckbox: "sps-selectbase",
    checkboxItem: "sps-checkbox",
    checkboxItemChecked: "sps-checkbox--checked",
    checkboxitemIndeterminate: "sps-checkbox--indeterminate",
    checkboxItemReadOnly: "sps-checkbox--disabled",
    svgIconId: "#icon-v2check",
    checkboxLabel: "sps-selectbase__label",
    controlCheckbox: "sps-checkbox__control",
    checkboxControlLabel: "sps-checkbox__caption",
    checkboxItemDecorator: "sps-checkbox__svg",
    checkboxMaterialDecorator: "sps-checkbox__rectangle"
  },
  text: {
    root: "sps-input sps-text",
    controlReadOnly: "sps-input--readonly",
    small: "sps-row__question--small",
    content: "sps-question__content sps-text__content",
    remainingCharacterCounter: "sps-remaining-character-counter",
    onError: "sps-input--error"
  },
  comment: {
    root: "sps-input sps-comment",
    content: "sps-question__content sps-comment__content",
    remainingCharacterCounter: "sps-remaining-character-counter",
    small: "sps-row__question--small",
    onError: "sps-input--error"
  },
  dropdown: {
    root: "sps-selectbase",
    popup: "sps-dropdown-popup svc-creator-popup",
    small: "sps-row__question--small sd-row__question--small",
    control: "sps-input sps-dropdown",
    controlEmpty: "sps-dropdown--empty sd-dropdown--empty",
    controlValue: "sps-dropdown__value",
    filterStringInput: "sd-dropdown__filter-string-input sps-dropdown__filter-string-input",
    other: "sps-comment sps-question__other",
    onError: "sps-input--error",
    selectWrapper: "sv-dropdown_select-wrapper sps-dropdown_select-wrapper",
    chevronButtonIconId: "icon-chevron",
    cleanButton: "sps-dropdown__clean-button sps-input__edit-button",
    controlReadOnly: "sps-input--readonly sd-input--disabled sd-input--readonly",
    hintPrefix: "sps-dropdown__hint-prefix sd-dropdown__hint-prefix",
    hintSuffix: "sps-dropdown__hint-suffix sd-dropdown__hint-suffix"
  },
  tagbox: {
    cleanItemButton: "sd-tagbox-item_clean-button sps-tagbox-item_clean-button",
    cleanItemButtonSvg: "sd-tagbox-item_clean-button-svg sps-tagbox-item_clean-button-svg",
    control: "sd-input sd-tagbox sd-dropdown sps-tagbox sps-dropdown",
    controlValue: "sd-tagbox__value sd-dropdown__value sps-tagbox__value",
    filterStringInput: "sd-dropdown__filter-string-input sps-dropdown__filter-string-input",
  },
  matrix: {
    tableWrapper: "sps-matrix sps-table-wrapper",
    root: "sps-table",
    rowError: "sps-matrix__row--error",
    cell: "sps-table__cell sps-matrix__cell",
    headerCell: "sps-table__cell sps-table__cell--header",
    label: "sps-item sps-radio sps-matrix__label",
    itemValue: "sps-visuallyhidden sps-item__control sps-radio__control",
    itemChecked: "sps-radio--checked",
    itemReadOnly: "sps-item--disabled sps-radio--disabled",
    itemHover: "sps-radio--allowhover",
    materialDecorator: "sps-item__decorator sps-radio__decorator",
    itemDecorator: "sps-item__svg sps-radio__svg",
    cellText: "sps-matrix__text",
    cellTextSelected: "sps-matrix__text--checked",
    cellTextReadOnly: "sps-matrix__text--disabled",
  },
  matrixdropdown: {
    tableWrapper: "sps-table-wrapper",
    root: "sps-table",
    cell: "sps-table__cell",
    headerCell: "sps-table__cell sps-table__cell--header",
    emptyCell: "sps-table__cell--empty",
    rowEnter: "sps-table__row--enter",
    rowLeave: "sps-table__row--leave",
  },
  matrixdynamic: {
    mainRoot: "sps-question sps-question--matrixdynamic sd-element sd-question sd-row__question sd-element--complex sd-question--complex sd-question--table",
    tableWrapper: "sps-table-wrapper",
    root: "sps-table sps-matrixdynamic",
    content: "sps-matrixdynamic__content sps-text__content",
    cell: "sps-table__cell",
    row: "sps-table__row",
    rowDisabled: "sps-table__row-disabled",
    rowReadOnly: "sps-table__row-readonly",
    headerCell: "sps-table__cell sps-table__cell--header",
    button: "sps-btn",
    detailRow: "sps-table__row sps-table__row--detail",
    detailButton: "sps-table__cell--detail-button sps-action-button sps-action-button--icon",
    detailButtonExpanded: "sps-table__cell--detail-button--expanded",
    detailIcon: "sps-detail-panel__icon sps-action-button__icon",
    detailIconExpanded: "sps-detail-panel__icon--expanded",
    detailIconExpandedId: "icon-collapse-24x24",
    detailIconId: "icon-expand-24x24",
    detailPanelCell: "sps-table__cell sps-table__cell--detail-panel",
    actionsCell: "sps-table__cell sps-table__cell--actions",
    buttonAdd: "sps-matrixdynamic__add-btn sps-action-button sps-action-button--large",
    buttonRemove: "",
    iconAdd: "",
    iconRemove: "#icon-delete-24x24",
    dragElementDecorator: "sps-drag-element__svg",
    iconDragElement: "#icon-drag-24x24",
    iconDrag: "sps-matrixdynamic__drag-element",
    footer: "sps-matrixdynamic__footer",
    dragDropGhostPositionTop: "sps-matrixdynamic__drag-drop-ghost-position-top",
    dragDropGhostPositionBottom: "sps-matrixdynamic__drag-drop-ghost-position-bottom",
    noRowsSection: "sps-matrixdynamic__placeholder",
    noRowsText: "sps-matrixdynamic__placeholder-text",
    cellQuestionWrapper: "sps-table__question-wrapper",
    draggedRow: "sps-matrixdynamic__dragged-row",
    emptyCell: "sps-table__cell--empty",
    rowEmpty: "sps-table__row--empty",
    rowEnter: "sps-table__row--enter",
    rowLeave: "sps-table__row--leave",
  },

  actionBar: {
    root: "sps-action-bar",
    item: "sps-action-button",
    itemPressed: "sps-action-button--pressed",
    itemAsIcon: "sps-action-button--icon",
    itemIcon: "sps-action-button__icon",
    itemTitle: "sps-action-button__title",
  }
};
